import { Chip } from '~/shared/ui'
import { getRunStatusTone } from '../lib'

export function RunStatusChip({ status }: { status: string }) {
  const tone = getRunStatusTone(status)

  return (
    <Chip
      rounded
      size="sm"
      success={tone === 'success'}
      error={tone === 'failed'}
    >
      {status}
    </Chip>
  )
}
